import dateformat from "dateformat";
import nl2br from "nl2br";
import UAParser from "ua-parser-js";

const userAgent = UAParser();
// utils
const $utils = {
  userAgent,
  isIE: userAgent.browser.name === "IE",
  dateformat(date, format, emptyStr = "-") {
    if (!date) return emptyStr;
    return dateformat(date, format);
  },
  dateText(date, emptyStr = "-") {
    return this.dateformat(date, "yyyy-mm-dd", emptyStr);
  },
  timeText(date, showSeconds, emptyStr = "-") {
    const format = showSeconds ? "yyyy-mm-dd HH:MM:ss" : "yyyy-mm-dd HH:MM";
    return this.dateformat(date, format, emptyStr);
  },
  datePeriodText(start, end, ...args) {
    return `${this.dateText(start, ...args)} ~ ${this.dateText(end, ...args)}`;
  },
  timePeriodText(start, end, ...args) {
    return `${this.timeText(start, ...args)} ~ ${this.timeText(end, ...args)}`;
  },
  excelName(...args) {
    const today = this.dateformat(new Date(), "yyyymmdd");
    return `${args.join("_")}_${today}`;
  },
  nl2br(str) {
    if (!str) return "";
    return nl2br(str);
  },
  stringToDate(str) {
    const result = new Date(str);
    return isNaN(result) ? null : result;
  },
  enableScroll(bln = true) {
    document.querySelector("html").style.overflow = bln ? "visible" : "hidden";
  },
  jsonToFormData(json) {
    const formData = new FormData();
    _.forEach(json, (val, key) => formData.append(key, val));
    return formData;
  },
  clearArray(arr) {
    arr.splice(0, arr.length);
  },
  assignIndex(arr) {
    _.forEach(arr, (item, index) => (item._index = index));
  },
  // 입력된 기간만큼 차감
  calcDate(date, period) {
    let result = date ? new Date(date) : new Date();
    const list = period.match(/[\d-]+[qmwdy]/g);
    if (list && list.length) list.forEach((item) => run(result, item));
    return result;

    function run(date, str) {
      const unit = str.slice(-1);
      const value = parseInt(str.replace(/^([\d-]+)[qmwdy]$/, "$1"), 10);
      switch (unit) {
        case "q":
          date.setMonth(date.getMonth() + value * 3);
          break;
        case "m":
          date.setMonth(date.getMonth() + value);
          break;
        case "w":
          date.setDate(date.getDate() + value * 7);
          break;
        case "d":
          date.setDate(date.getDate() + value);
          break;
        case "y":
          date.setFullYear(date.getFullYear() + value);
          break;
      }
    }
  },
  hasSpecialChar(str) {
    const regExp = /[^가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z0-9|\ ]/gi;
    return regExp.test(str);
  },
};

export default $utils;
